import Suspicious from './suspicious';

export default Suspicious;
